import { render, staticRenderFns } from "./LabelPrimary.vue?vue&type=template&id=014bc78a&scoped=true&lang=pug"
import script from "./LabelPrimary.vue?vue&type=script&lang=js"
export * from "./LabelPrimary.vue?vue&type=script&lang=js"
import style0 from "./LabelPrimary.vue?vue&type=style&index=0&id=014bc78a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014bc78a",
  null
  
)

export default component.exports